export const ACTION_TYPES = {
    CLEAR_AUTHENTICATION_ERROR: 'CLEAR_AUTHENTICATION_ERROR',
    CLEAR_AUTHENTICATION_USER: 'CLEAR_AUTHENTICATION_USER',

    LOAD_USER_REQUEST: 'LOAD_USER_REQUEST',
    LOAD_USER_SUCCESS: ' LOAD_USER_SUCCESS',
    LOAD_USER_FAILURE: ' LOAD_USER_FAILURE',

    CHANGE_FORM_FIELD: 'CHANGE_FORM_FIELD',
    CLEAR_FORM_FIELD: 'CLEAR_FORM_FIELD',

    VALIDATION_ERROR: 'VALIDATION_ERROR',
};
